const axiosInstance = require('./axiosInstance');

const getInfoByCode = async (code) => {
    try {
        const response = await axiosInstance.get(`/post-code/code/${code}`);
        return response.data;
    } catch
        (error) {
        throw error;
    }
}


const PostCodeService = {
    getInfoByCode
}

module.exports = PostCodeService;
